import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useDocument } from '@hooks/useDocument';
import { Icon } from 'fpay-ui';
import { downloadFile } from '../../helpers/utils';

const Button = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
  width: 200px;
  padding: 11px 14px 10px 14px;
  border-radius: 4px;
  border: solid 2px #43b22a;
  margin-left: auto;
  margin-top: 16px;
  margin-bottom: -16px;
  cursor: pointer;
  && div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  && span {
    width: 110px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #43b22a;
    margin-right: 14px;
  }
  && img {
    width: 24px;
    margin-right: 5px;
  }
`;

function DownloadAllDocuments() {
  const { t } = useTranslation();
  const { documents, downloadDocument } = useDocument();

  const handleDownloadAll = async () => {
    const docs = documents.filter(
      (document) => document.status === 'APPROVED' || document.status === 'REJECTED'
    );
    docs.forEach(async (data) => {
      const { file } = await downloadDocument(data.type);
      downloadFile(data.file, file);
    });
  };

  return (
    <Button onClick={handleDownloadAll} data-testid="btnDownloadAllDocuments">
      <div>
        <Icon icon="ic-downloadAll" />
        <span> {t('documentation.downloadButton')}</span>
      </div>
    </Button>
  );
}

export default DownloadAllDocuments;
